var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBinGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2043_67)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5756 39.176C30.3862 39.1909 39.1621 30.4393 39.1771 19.6286C39.192 8.81793 30.4404 0.0420293 19.6297 0.0270824C8.81903 0.0121355 0.0431352 8.7638 0.0281883 19.5745C0.0132414 30.3851 8.7649 39.161 19.5756 39.176Z",
    fill: "#E9EBED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2043_67",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 25,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0659 8.08536V31.0639H8.08743V8.08536H31.0659Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.851064
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2043_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6344 14.4681H27.5209",
    stroke: "#9BA7B6",
    strokeWidth: 1.70213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6261 14.6099L13.6191 26.5248C13.6191 27.0515 13.8283 27.5566 14.2007 27.9289C14.5731 28.3014 15.0782 28.5106 15.6049 28.5106H23.5481C24.0748 28.5106 24.5799 28.3014 24.9523 27.9289C25.3247 27.5566 25.534 27.0515 25.534 26.5248L26.5268 14.6099",
    stroke: "#9BA7B6",
    strokeWidth: 1.70213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5978 14.3121V11.3334C16.5978 11.07 16.7025 10.8174 16.8887 10.6312C17.0748 10.445 17.3274 10.3404 17.5907 10.3404H21.5624C21.8257 10.3404 22.0782 10.445 22.2644 10.6312C22.4506 10.8174 22.5552 11.07 22.5552 11.3334V14.3121",
    stroke: "#9BA7B6",
    strokeWidth: 1.70213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5908 19.5745L21.5625 23.5461M21.5625 19.5745L17.5908 23.5461",
    stroke: "#9BA7B6",
    strokeWidth: 1.70213,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2043_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBinGrey);
export default __webpack_public_path__ + "static/media/Icon_Bin_Grey.8de78d89b479477588b658ee847118c7.svg";
export { ForwardRef as ReactComponent };